<template>
  <RenderlessLookup
    v-slot="{ options, setSearch }"
    :endpoint="(props.endpoint as string)"
    :displayKey="(props.displayKey as string)"
    :valueKey="(props.valueKey as string)"
    :responseKey="props.responseKey"
    :limit="props.limit"
    :filter="props.filter"
    :currentValue="value"
    :tokenData="props.tokenData"
    v-if="props.fetchOptions"
  >
    <!-- @before-show="populateOptions()" -->
  </RenderlessLookup>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-1" v-else>
      <template v-for="option in props.options">
        <div class="flex flex-row gap-1 items-center text-base text-primary-400 h-8">
          <PrimeRadioButton
            v-model:model-value="value"
            :inputId="String(option['value'])"
            :name="option['name']"
            :value="option['value']"
          />
          <label :for="option['value']">{{ option["name"] }}</label>
        </div>
      </template>
    </div>
</template>

<script setup lang="ts">
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    options?: any[];
    fetchOptions?: boolean;
    endpoint?: string;
    displayKey?: string;
    valueKey?: string;
    responseKey?: string;
    limit?: number;
    filterEnabled?: boolean;
    filter?: { [key: string]: any };
    tokenData?: { [key: string]: any };
    placeholder?: string;
  }>(),
  {
    disabled: false,
    displayKey: 'name',
    valueKey: 'value',
    loading: false,
    fetchOptions: false,
    responseKey: "Results",
    limit: 40,
    filterEnabled: true,
    filter: () => ({}),
  }
);

const value = defineModel<any>("value");

const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== "") {
    return true;
  }
  return false;
});

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();

watch(() => value.value, (newValue) => {
  changeEventHandler({});
  inputEventHandler({});
  blurEventHandler({});
})

function changeEventHandler($event: any) {
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
